let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("bEDzq")]).then(() => parcelRequire('2gsxL'));